import Skeleton from "@mui/material/Skeleton";
import styles from "./EconomicCalendar.module.scss";

export const CalendarSkeletonLoader = () => (
    <div className={styles.skeletonContainer}>
        {Array.from({ length: 6 }).map((_, index) => (
            <div className={styles.skeletonItem} key={index}>
                <Skeleton
                    variant="circular"
                    sx={{ backgroundColor: "#F5F5F5" }}
                    width={24}
                    height={24}
                />
                <div className={styles.rightContent}>
                    <div className={styles.rightContentTop}>
                        <Skeleton
                            variant="rectangular"
                            sx={{ backgroundColor: "#F5F5F5" }}
                            width={208}
                            height={21}
                        />
                        <Skeleton
                            variant="rectangular"
                            sx={{ backgroundColor: "#F5F5F5" }}
                            width={52}
                            height={21}
                        />
                    </div>
                    <Skeleton
                        variant="rectangular"
                        sx={{ backgroundColor: "#F5F5F5" }}
                        width={272}
                        height={34}
                    />
                </div>
            </div>
        ))}
    </div>
);
